export default __webpack_public_path__ + "static/media/Emi-Banner.55dc5fe6.jpg";